import React from 'react';
import {
  Gender,
  VOICE_GENDER_FEMALE,
  VOICE_GENDER_MALE,
} from '../../../data/models/AI/VideoGenerationOptions';
import './styles.css';

interface Props {
  selectedOption: Gender;
  onSelectOption: (selected: Gender) => void;
}

const MaleFemaleSelect = React.memo(
  ({selectedOption, onSelectOption}: Props) => {
    const femaleFill =
      selectedOption === VOICE_GENDER_FEMALE
        ? 'var(--primary-color-1, #9EA5AD)'
        : '#9EA5AD';
    const maleFill =
      selectedOption === VOICE_GENDER_MALE
        ? 'var(--primary-color-1, #9EA5AD)'
        : '#9EA5AD';

    return (
      <div className="MaleFemaleVoiceContainer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          onClick={() => onSelectOption(VOICE_GENDER_FEMALE)}
          className="FemaleVoice">
          <path
            d="M45 22.5C45 29.61 41.702 35.95 36.5525 40.0735C31.937 42.1565 27.816 40.5 22.5 40.5C17.184 40.5 12.68 41.556 8.44751 40.0735C3.298 35.95 0 29.61 0 22.5C0 10.0735 10.0735 0 22.5 0C34.9265 0 45 10.0735 45 22.5Z"
            fill="#E5E7EA"
            stroke={
              selectedOption === VOICE_GENDER_FEMALE
                ? 'var(--primary-color-1, #9EA5AD)'
                : 'none'
            }
          />
          <path
            d="M32.5157 35.3845L30.3332 34.1655C28.5052 33.1445 27.1257 31.5395 26.3687 29.6595C26.7912 29.185 27.1797 28.6525 27.5252 28.082C29.0042 27.745 30.4982 27.273 32.0087 26.653C30.8007 25.18 30.3822 24.2295 30.9717 19.802C31.6372 13.467 27.1982 10.159 22.4997 10.0215C17.8012 10.159 13.3622 13.467 14.0277 19.8025C14.6172 24.2295 14.1987 25.1805 12.9907 26.6535C14.5012 27.2735 15.9952 27.7455 17.4742 28.0825C17.8197 28.6525 18.2082 29.1855 18.6307 29.66C17.8732 31.54 16.4942 33.145 14.6662 34.166L12.4837 35.385C10.5982 36.438 9.19167 38.112 8.45117 40.0685C12.3012 43.151 17.1832 44.999 22.4997 44.999C27.8162 44.999 32.6982 43.151 36.5487 40.068C35.8082 38.1115 34.4012 36.4375 32.5157 35.3845Z"
            fill={femaleFill}
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          onClick={() => onSelectOption(VOICE_GENDER_MALE)}>
          <path
            d="M22.5 40.4999C16.6212 40.4999 12.2578 39.9758 7.35606 38.4579C3.13261 34.4488 0.5 28.7821 0.5 22.5C0.5 10.3496 10.3496 0.5 22.5 0.5C34.6503 0.5 44.4999 10.3496 44.4999 22.5C44.4999 28.7979 41.854 34.4773 37.612 38.4881C33.3144 40.673 29.843 40.6119 25.3199 40.5321C24.4258 40.5164 23.4907 40.4999 22.5 40.4999Z"
            fill="#E5E7EA"
            stroke={
              selectedOption === VOICE_GENDER_MALE
                ? 'var(--primary-color-1, #9EA5AD)'
                : 'none'
            }
          />
          <path
            d="M33.6595 34.2874L31.228 32.9294C29.44 31.9309 28.035 30.4324 27.1475 28.6644C28.3815 26.8754 29.1835 24.6064 29.283 22.7219H29.294L29.967 19.7144C30.116 19.0484 29.814 18.4124 29.294 18.0679V16.9784C29.294 13.8649 27.1975 10.311 24.341 9.18745L24.3455 9.17995C22.9405 8.54596 21.029 8.58796 20.134 8.82096C21.0585 9.15295 21.5515 10.0995 20.3465 10.534L20.3575 10.5345C17.6565 11.4324 15.7065 13.9754 15.7065 16.9779V18.0674C15.186 18.4119 14.8845 19.0474 15.0335 19.7139L15.7065 22.7214H15.7175C15.817 24.6059 16.6185 26.8749 17.853 28.6639C16.9655 30.4319 15.56 31.9304 13.7725 32.9289L11.3411 34.2869C9.43906 35.3489 7.97506 36.9794 7.10156 38.8959C11.1266 42.6784 16.5405 44.9994 22.5 44.9994C28.4595 44.9994 33.8735 42.6784 37.899 38.8964C37.026 36.9799 35.5615 35.3494 33.6595 34.2874Z"
            fill={maleFill}
          />
        </svg>
      </div>
    );
  },
);

export default MaleFemaleSelect;
